<template>
  <div class="content w-100" v-for="client in companies" :key="client.name">
    <div class="title bg-success"><router-link :to="`/empresas/${client.id}?mode=view`"  target="_blank"><a> {{ client.name }}</a> </router-link></div>

    <div class="zabbix" v-for="zabbix in client.zabbixs" :key="zabbix.name">
      <ProblemsAcknowleged :zabbixId="zabbix.id" :companyId="client.id" :updateTime="updateTime" :problemsPerPage="problemsPerPage"
        :title="client.name"/>
    </div>
  </div>
</template>

<script>
import { updateTime, problemsPerPage } from '@/configs/general';
import { CompanyService } from '@/services/backend/ApiService';
import ProblemsAcknowleged from '@/pages/resolution/ProblemsAcknowleged.vue';

export default {
  components: {
    ProblemsAcknowleged,
  },
  data() {
    return {
      companies: [],
      updateTime,
      problemsPerPage,
      interval: null,
      showingClients: []
    };
  },
  async mounted() {
    this.companies = await CompanyService.findAll();
  },
};
</script>

<style scoped>
body,
html,
.content {
  background: rgb(255, 255, 255);
}

.content:has(.table, .alert) .title {
  display: flex;
 
}

.alert {
  height: 50px;

}

.title {
  display: none;
}

a{
  color: white;
}
</style>
